import ApiStatus  from "./ApiStatus";

//console.log("Checking api status...");
ApiStatus.check();



// WEBPACK FOOTER //
// dev/js/AGLC_main.js